import React, { useEffect } from 'react';
import usePageMeta from '../hooks/usePageMeta';
import styles from './bodytext.module.css'; // Import the CSS module
import contactStyles from './Contact.module.css';

const Contact = () => {
  usePageMeta(
    'Contact Us & Find Us | Vintage in Oulton',
    'Get in touch with Vintage in Oulton by phone, WhatsApp or email, or find our shop at 81-83 Aberford Road, Oulton, Leeds.'
  );

  useEffect(() => {
    // Define initMap function globally
    window.initMap = function() {
      const mapElement = document.getElementById('map');
      if (window.google && mapElement) {
        const map = new window.google.maps.Map(mapElement, {
          center: { lat: 53.75252211029793, lng: -1.4471098680939694 },
          zoom: 17,
          mapId: '964502a05443f89e'
        });

        const contentString = `
          <div style="background: white; padding: 5px; border-radius: 5px;">
            <h3>Vintage in Oulton</h3>
            <p>81-83 Aberford Road, Leeds, LS26 8SL, United Kingdom</p>
            <a href="https://www.google.com/maps/dir/Current+Location/81-83 Aberford Road, Leeds, United Kingdom" target="_blank" onclick="trackMapDirectionsClick()">Get Directions</a>
          </div>`;

        const markerElement = new window.google.maps.marker.AdvancedMarkerElement({
          position: { lat: 53.75252211029793, lng: -1.4471098680939694 },
          map: map,
          title: 'Vintage in Oulton'
        });

        const infowindow = new window.google.maps.InfoWindow({
          content: contentString
        });

        markerElement.addListener('click', function() {
          infowindow.open({ anchor: markerElement, map });
        });
      }
    };

    // Track map directions click event
    window.trackMapDirectionsClick = function() {
      if (window.gtag) {
        window.gtag('event', 'map_directions_click', {
          event_category: 'Map Interaction',
          event_label: 'Map Directions Click'
        });
      }
    };

    // Load the Google Maps script only if not already loaded
    const mapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    const existingScript = document.querySelector('script[src^="https://maps.googleapis.com/maps/api/js"]');
    if (!existingScript && mapsApiKey) {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${mapsApiKey}&callback=initMap&libraries=marker`;
      script.async = true;
      script.defer = true;
      script.onerror = function() {
        console.error('Google Maps script failed to load.');
      };
      document.head.appendChild(script);
    } else if (existingScript && window.google) {
      // Script already loaded from a previous visit — initialise the map directly
      window.initMap();
    }
  }, []);

  return (
    <div className={styles.bodytext}>
      <div className={contactStyles.layout}>
        <div className={styles.textContainer}>
          <h2>How to get in touch</h2>
          <br />
          <p><b>Phone:</b> <a href="tel:+441133934720">0113 3934720</a></p>
          <p><b>Whatsapp:</b> <a href="https://wa.me/447795365104" target="_blank" rel="noopener noreferrer">07795365104</a> / <a href="https://wa.me/447717523816" target="_blank" rel="noopener noreferrer">07717523816</a></p>
          <p><b>Email:</b> <a href="mailto:vintageinoulton@gmail.com">vintageinoulton@gmail.com</a></p>
          <p><b>Instagram:</b> <a href="https://instagram.com/vintage.in.oulton" target="_blank" rel="noopener noreferrer">instagram.com/vintage.in.oulton</a></p>
          <p><b>Facebook:</b> <a href="https://facebook.com/vintageinoulton" target="_blank" rel="noopener noreferrer">facebook.com/vintageinoulton</a></p>
        </div>
        <div className={styles.textContainer}>
          <h2>Where to find us:</h2>
          <br />
          <p>81-83 Aberford Road, Oulton, Leeds, LS26 8SL</p>
          <br />
          <p>Find us next to Cooper’s Ford garage and a minute's walk from Lidl with 90 minutes free parking. Free street parking is available locally.</p>
          <br />
        </div>
      </div>
      <div id="map" className={contactStyles.map}></div>
    </div>
  );
};

export default Contact;
